/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ersthelferkursabsolviertam2Inputs */

const de__field_ersthelferkursabsolviertam2 = /** @type {(inputs: _Field_Ersthelferkursabsolviertam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersthelferkurs absolviert am`)
};

/**

* @param {_Field_Ersthelferkursabsolviertam2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ersthelferkursabsolviertam2 = /** @type {((inputs?: _Field_Ersthelferkursabsolviertam2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ersthelferkursabsolviertam2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_ersthelferkursabsolviertam2(inputs)
});
export { _field_ersthelferkursabsolviertam2 as "_field_ersthelferkursAbsolviertAm" }